import React from 'react';
import './dynamicbackground.css';

const DynamicBackground = () => {
  return (
    <div className="area">
      <ul className="circles">
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
        <li className="circlebox" />
      </ul>
    </div>
  );
};

export default DynamicBackground;
